import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  createLearningPath,
  editLearningPath,
} from "../../../api/endpoints/LearningPathEndpoints";
import { LearningPathRequest } from "../../../models/LearningPath";

export default function useCreateOrEditLearningPath() {
  return useMutation<
    { id: number },
    AxiosError,
    { learningPath: LearningPathRequest; operation: "create" | "edit" }
  >({
    mutationKey: ["create-or-edit-learning-path"],
    mutationFn: ({ learningPath, operation }) =>
      operation === "create"
        ? createLearningPath(learningPath)
        : editLearningPath(learningPath),
  });
}
